import { schedule } from "@ember/runloop";
import { classNames } from "@ember-decorators/component";
import { escapeExpression } from "discourse/lib/utilities";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const CreateColorRow = dt7948.c(class CreateColorRow extends SelectKitRowComponent {
  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    schedule("afterRender", () => {
      const color = escapeExpression(this.rowValue);
      this.element.style.borderLeftColor = color.startsWith("#") ? color : `#${color}`;
    });
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <span>{{this.label}}</span>\n  ", {
      strictMode: true
    }), this);
  }
}, [classNames("create-color-row")]);
export default CreateColorRow;